module.exports = __webpack_public_path__ + "static/media/no5.6eb6dcbf.png";